<div class='message-component'>{{message}} <mat-icon>hourglass_empty</mat-icon></div>